import script from "./ReImg.vue?vue&type=script&setup=true&lang=js"
export * from "./ReImg.vue?vue&type=script&setup=true&lang=js"

import "./ReImg.vue?vue&type=style&index=0&id=1e73296c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e73296c"]])

export default __exports__